import { NsCard } from 'components/common/ns-card/NsCard';
import { NsPrimaryCta } from 'components/common/ns-primary-cta/NsPrimaryCta';
import { FUEL_OPTIONS } from 'config/app-config';
import { TrackedCta } from 'components/direct-sales/select-options/components/TrackedCta';
import { capitalize } from 'utils/misc';
import { useHasMixedMeters } from 'hooks/useHasMixedMeters';
import { useNavigation } from 'hooks/useNavigation';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { setElectric, setGas } from 'state/fuel-type/fuel-type-slice';
import { setPersonaliseQuoteShowFuel } from 'state/settings/settings-slice';
import { setValidationRequired } from 'state/meterpoint-validation/meterpoint-validation-slice';

type MixedMeterCardProps = {
  name: string;
  decoration: 'bulb' | 'gas';
  fuelType: typeof FUEL_OPTIONS[keyof typeof FUEL_OPTIONS];
};

export const MixedMeterCard = ({
  name,
  decoration,
  fuelType
}: MixedMeterCardProps) => {
  const dispatch = useAppDispatch();
  const hasMixedMeters = useHasMixedMeters();
  const capitalizedFuelType = capitalize(fuelType);
  const { eventTypes, next } = useNavigation();

  const handleGoNext = () => {
    next({ eventType: eventTypes.MIXED_METERS });

    if (fuelType === FUEL_OPTIONS.ELECTRIC) {
      dispatch(setElectric());
    } else {
      dispatch(setGas());
    }
    dispatch(setPersonaliseQuoteShowFuel(false));
    dispatch(
      setValidationRequired({
        electricity: false,
        gas: false
      })
    );
  };

  if (!hasMixedMeters) {
    return null;
  }

  return (
    <NsCard
      decoration={decoration}
      heading={`Start with a quote for your ${capitalizedFuelType}`}
      testId={`${fuelType}MixedMeterCardTestId`}
      action={
        <TrackedCta name={name}>
          <NsPrimaryCta onClick={handleGoNext}>
            Get {fuelType === FUEL_OPTIONS.ELECTRIC ? 'an' : 'a'}{' '}
            {capitalizedFuelType} quote
          </NsPrimaryCta>
        </TrackedCta>
      }
    >
      <p>You&apos;ll find our cheapest {fuelType} tariffs right here.</p>
    </NsCard>
  );
};
